
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 384 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M374.6 150.6L233.3 9.3C227.4 3.371 219.2 0 210.7 0H64C28.65 0 0 28.65 0 64l.006 384c0 35.34 28.65 64 64 64H320c35.35 0 64-28.66 64-64V173.3c0-8.5-3.4-16.7-9.4-22.7zM224 22.63L361.4 160H248c-13.2 0-24-10.8-24-24V22.63zM368 448c0 26.47-21.53 48-48 48H64c-26.47 0-48-21.53-48-48V64c0-26.47 21.53-48 48-48h144v120c0 22.06 17.94 40 40 40h120v272zM64 256v160c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32V256c0-17.67-14.33-32-32-32H96c-17.67 0-32 14.3-32 32zm56 176H96c-8.822 0-16-7.176-16-16v-32h40v48zm0-64H80v-48h40v48zm64 64h-48v-48h48v48zm0-64h-48v-48h48v48zm64 64h-48v-48h48v48zm0-64h-48v-48h48v48zm56 48c0 8.824-7.178 16-16 16h-24v-48h40v32zm0-48h-40v-48h40v48zm0-112v48H80v-48c0-8.824 7.178-16 16-16h192c8.8 0 16 7.2 16 16z"}})])
          )
        }
      }
    